export class RequisitionDisplaySelectedFilter {
  searchString = '';
  clientOrBU: any[] = [];
  roleList: any[] = [];
  requisitionTypes: any[] = [];
  requisitionStates: any[] = [];
  requisitionNums: any[] = [];
  recruiters: any[] = [];
  jobTypes: any[] = [];
  workLocationIds: any[] = [];
  selectedFilterSort = '';
  showDisplayFilterIconFlag = true;
}
